import { render } from "./TheFooter.vue?vue&type=template&id=2ac355ea"
import script from "./TheFooter.vue?vue&type=script&lang=ts"
export * from "./TheFooter.vue?vue&type=script&lang=ts"
script.render = render

export default script